import { useState } from "react";
import PropTypes from "prop-types"; // Hinzugefügt

// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";

function ForWhat({ onNext, onBack }) {
  const [selectedService, setSelectedService] = useState(null);

  const handleSetService = (service) => {
    setSelectedService(selectedService === service ? null : service);
  };

  const handleNext = () => {
    if (selectedService) {
      onNext(selectedService);
    } else {
      alert("Bitte wählen Sie einen Dienst aus.");
    }
  };

  const customButtonStyles = ({
    functions: { pxToRem, rgba },
    borders: { borderWidth },
    palette: { transparent, dark, secondary },
  }) => ({
    width: pxToRem(200),
    height: pxToRem(120),
    borderWidth: borderWidth[2],
    mb: 1,
    ml: 0.5,

    "&.MuiButton-contained, &.MuiButton-contained:hover": {
      boxShadow: "none",
      border: `${borderWidth[2]} solid ${transparent.main}`,
    },

    "&:hover": {
      backgroundColor: `${transparent.main} !important`,
      border: `${borderWidth[2]} solid ${secondary.main} !important`,

      "& svg g": {
        fill: rgba(dark.main, 0.75),
      },
    },
  });

  return (
    <SoftBox>
      <SoftBox width="80%" textAlign="center" mx="auto" mb={4}>
        <SoftBox mb={1}>
          <SoftTypography variant="h5" fontWeight="regular">
            Welche Dienste möchten Sie nutzen? (Checkboxes)
          </SoftTypography>
        </SoftBox>
        <SoftTypography variant="body2" fontWeight="regular" color="text">
          Wählen Sie die gewünschten Dienste aus, um mehr über die Preise und Funktionen zu erfahren.
        </SoftTypography>
      </SoftBox>
      <SoftBox mt={2}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} sm={4}>
            <SoftBox textAlign="center">
              <SoftButton
                color="secondary"
                variant={selectedService === "cloudBackup" ? "contained" : "outlined"}
                onClick={() => handleSetService("cloudBackup")}
                sx={customButtonStyles}
              >
                <SoftTypography variant="button" color={selectedService === "cloudBackup" ? "white" : "dark"}>
                  UDS Cloud Backup
                  <br />
                  (ab 6,99 €)
                </SoftTypography>
              </SoftButton>
            </SoftBox>
          </Grid>
          <Grid item xs={12} sm={4}>
            <SoftBox textAlign="center">
              <SoftButton
                color="secondary"
                variant={selectedService === "webDav" ? "contained" : "outlined"}
                onClick={() => handleSetService("webDav")}
                sx={customButtonStyles}
              >
                <SoftTypography variant="button" color={selectedService === "webDav" ? "white" : "dark"}>
                  WebDAV, SMB, SSH, RClone
                  <br />
                  (ab 7,99 €)
                </SoftTypography>
              </SoftButton>
            </SoftBox>
          </Grid>
        </Grid>
      </SoftBox>
      <SoftBox mt={4} display="flex" justifyContent="space-between">
        <SoftButton color="light" onClick={onBack}>
          Zurück
        </SoftButton>
        <SoftButton color="primary" onClick={handleNext}>
          Weiter
        </SoftButton>
      </SoftBox>
    </SoftBox>
  );
}

ForWhat.propTypes = {
  onNext: PropTypes.func.isRequired, // PropTypes angepasst
  onBack: PropTypes.func.isRequired,
};

export default ForWhat;
